import React from 'react';
import SectionHeader from './SectionHeader';
import RYGRadio from './RYGRadio';
import NotesInput from './NotesInput';

const OPTIONS = [
  { value: 'red', label: "I'm disappointed with my growth, or I don't measure my return" },
  { value: 'yellow', label: 'My assets are growing… but is it enough?' },
  { value: 'green', label: "I'm getting the growth I need to fund my dreams" },
];

/**
 * Section 5 — Growth Satisfaction.
 */
export default function StepGrowthSatisfaction({ data, onChange }) {
  return (
    <div>
      <SectionHeader
        number={5}
        title="How happy are you with the growth of your assets and investments?"
        showAnnualNote={false}
      />
      <div className="cashflow-section-card">
        <RYGRadio
          id="growth_satisfaction"
          options={OPTIONS}
          value={data?.answer}
          onChange={(val) => onChange({ ...(data || {}), answer: val })}
        />
      </div>

      <NotesInput
        value={data?.notes}
        onChange={(val) => onChange({ ...(data || {}), notes: val })}
      />
    </div>
  );
}
